module.exports = __webpack_public_path__ + "img/Brightness1Outlined.e3438950.svg";